const STORAGE_OBJECT_MARKER = '/api/storage/object/'
const WORKSPACE_STORAGE_MARKER = '/workspaces/'

function encodeStorageKey(key: string): string {
  return key
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/')
}

function getLocalFileStorageKey(url: string): string | null {
  if (!url.startsWith('file://')) return null

  try {
    const parsedUrl = new URL(url)
    const workspaceMarkerIndex = parsedUrl.pathname.indexOf(
      WORKSPACE_STORAGE_MARKER
    )
    if (workspaceMarkerIndex === -1) return null

    return decodeURIComponent(parsedUrl.pathname.slice(workspaceMarkerIndex + 1))
  } catch {
    return null
  }
}

export function resolveStorageImageUrl(url: string | null | undefined): string {
  if (!url) return ''

  const markerIndex = url.indexOf(STORAGE_OBJECT_MARKER)
  if (markerIndex !== -1) return url.slice(markerIndex)

  if (url.startsWith('workspaces/')) {
    return `${STORAGE_OBJECT_MARKER}${encodeStorageKey(url)}`
  }

  const localFileStorageKey = getLocalFileStorageKey(url)
  if (localFileStorageKey) {
    const storageKey = localFileStorageKey
    return `${STORAGE_OBJECT_MARKER}${encodeStorageKey(storageKey)}`
  }

  return url
}

export function isStorageImageUrl(url: string | null | undefined): boolean {
  return resolveStorageImageUrl(url).startsWith(STORAGE_OBJECT_MARKER)
}
